import { Children } from "react";
import { FormGroup } from "../../../components/form";
import * as yup from "yup";

const today = new Date();
const threeMonthsFuture = new Date();
threeMonthsFuture.setMonth(today.getMonth() + 3);

export const applicationChecklistForm = (
  triggerIssuesFoundModal: (newData: any, newEmailStatus: any) => void,
  triggerNoIssuesFoundEmail: (newData: any) => void
) => {
  const form: FormGroup = {
    type: "formGroup",
    warn: "Complete the following checklist relating to the KIS application",
    disabledExpression: (context, values) => values.emailStatus != ChecklistEmailStatus.NoEmailSent && values.emailStatus != null,
    fields: [
      {
        type: "field",
        fieldType: "advisory",
        props: {
          type: "warning",
        },
        key: "advisory",
        label: "Responses recorded in this application will be included in the advisory email sent to the kindergarten regarding their application.",
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "specialistTrainingIncomplete",
        label: "Specialist training request incomplete",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "specialistTrainingIncompleteDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.specialistTrainingIncomplete,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "minorBuildingModificationsIncomplete",
        label: "Minor building modifications request incomplete",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "minorBuildingModificationsIncompleteDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.minorBuildingModificationsIncomplete,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "attendanceHoursClarification",
        label: "Attendance hours clarification",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "attendanceHoursClarificationDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.attendanceHoursClarification,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "kinderGroupNameClarification",
        label: "Kinder group name clarification",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "kinderGroupNameClarificationDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.kinderGroupNameClarification,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "bushKinderDates",
        label: "Bush kinder dates",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "bushKinderDatesDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.bushKinderDates,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "groupSizeClarification",
        label: "Group size clarification",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "groupSizeClarificationDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.groupSizeClarification,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "staffToChildRatioClarification",
        label: "Staff to child ratio clarification",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "staffToChildRatioClarificationDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.staffToChildRatioClarification,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "yearAppliedForClarification",
        label: "Year applied for clarification",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "yearAppliedForClarificationDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.yearAppliedForClarification,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "commencementDateClarification",
        label: "Commencement date clarification",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "commencementDateClarificationDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.commencementDateClarification,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "programTypeClarification",
        label: "Program type (3/4/ESK) clarification",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "programTypeClarificationDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.programTypeClarification,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "schoolExemptionNotSubmitted",
        label: "School exemption not submitted",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "schoolExemptionNotSubmittedDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.schoolExemptionNotSubmitted,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "disabilityOrDiagnosisClarification",
        label: "Disability/diagnosis clarification",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "disabilityOrDiagnosisClarificationDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.disabilityOrDiagnosisClarification,
      },

      {
        type: "field",
        fieldType: "checkbox",
        key: "interestsIncomplete",
        label: "Interests incomplete",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "interestsIncompleteDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.interestsIncomplete,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "strengthsAndAbilitiesIncomplete",
        label: "Strengths and abilities incomplete",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "strengthsAndAbilitiesIncompleteDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.strengthsAndAbilitiesIncomplete,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "groupedBehaviours",
        label: "Behaviours on behaviour chart are grouped",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "groupedBehavioursDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.groupedBehaviours,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "cmnDiagnosisClarification",
        label: "CMN diagnosis clarification",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "cmnDiagnosisClarificationDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.cmnDiagnosisClarification,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "parentConsentFormIncomplete",
        label: "Parent consent form missing/incomplete",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "parentConsentFormIncompleteDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.parentConsentFormIncomplete,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "cmnEvidenceMissing",
        label: "CMN evidence missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "cmnEvidenceMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.cmnEvidenceMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "riskMinimisationPlanIncomplete",
        label: "Risk minimisation plan missing/incomplete",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "riskMinimisationPlanIncompleteDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.riskMinimisationPlanIncomplete,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "medicalManagementPlanIncomplete",
        label: "Medical management plan missing/incomplete",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "medicalManagementPlanIncompleteDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.medicalManagementPlanIncomplete,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "disabilityEvidenceMissing",
        label: "Disability evidence missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "disabilityEvidenceMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.disabilityEvidenceMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "adhdEvidence",
        label: "Disability evidence -ADHD",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "adhdEvidenceDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.adhdEvidence,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "undergoingAssessmentEvidenceMissing",
        label: "Undergoing assessment evidence missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "undergoingAssessmentEvidenceMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.undergoingAssessmentEvidenceMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "kisPlanIncomplete",
        label: "KIS plan missing/incomplete",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "kisPlanIncompleteDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.kisPlanIncomplete,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "kisPlanPdQuestionsMissed",
        label: "KIS plan PD question missed",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "kisPlanPdQuestionsMissedDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.kisPlanPdQuestionsMissed,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "kisPlanNotCurrent",
        label: "KIS plan not current",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "kisPlanNotCurrentDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.kisPlanNotCurrent,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "kisPlanSameAsPreviousPlan",
        label: "KIS plan same as previous plan",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "kisPlanSameAsPreviousPlanDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.kisPlanSameAsPreviousPlan,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "psgTableIncomplete",
        label: "PSG table missing/incomplete",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "psgTableIncompleteDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.psgTableIncomplete,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "bushKinderRmpIncomplete",
        label: "Bush Kinder risk minimisation plan missing/incomplete",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "bushKinderRmpIncompleteDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.bushKinderRmpIncomplete,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "bushKinderIncorrectRmpProgramDate",
        label: "Bush kinder RMP program date incorrect",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "bushKinderIncorrectRmpProgramDateDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.bushKinderIncorrectRmpProgramDate,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "specialistTrainingQuotesIncomplete",
        label: "Specialist training quotes missing/incomplete",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "specialistTrainingQuotesIncompleteDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.specialistTrainingQuotesIncomplete,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "specialistTrainingQuotesClarification",
        label: "Specialist training quotes clarification",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "specialistTrainingQuotesClarificationDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.specialistTrainingQuotesClarification,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "minorBuildingModificationsQuotesIncomplete",
        label: "Minor building modifications quotes missing/incomplete",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "minorBuildingModificationsQuotesIncompleteDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.minorBuildingModificationsQuotesIncomplete,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "appealConsentFormMissing",
        label: "Appeal consent form missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "appealConsentFormMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.appealConsentFormMissing,
      },
      {
        type: "field",
        fieldType: "error",
        key: "chooseOne",
        validation: yup.mixed().when("$issuesFound", {
          is: true,
          then: (schema) =>
            schema.test("chooseOne", "A response is required", function (value) {
              return oneChosen(value);
            }),
        }),
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "summary",
        label: "Summary",
        warn: "This will be provided to the kindergarten",
      },
      {
        type: "field",
        fieldType: "button",
        label: "No Issues Found Email",
        key: "button4",
        props: {
          className: "form-button mb-2",
        },
        expressionProps: {
          disabled: (context, values) => values.emailStatus === ChecklistEmailStatus.NoIssuesFound,
          onClick: (context, values) => () => {
            context.issuesFound = false;
            triggerNoIssuesFoundEmail(values);
          },
        },
        hideExpression: (context, values) => values.outdated || context.disabled,
      },
      {
        type: "formGroup",
        key: "emailGroup",
        hideExpression: (context, values) => values.outdated || context.disabled,
        customWrapper: ({ children }: any) => (
          <div key={children.key} className="grid" style={{ maxWidth: "1250px" }}>
            {Children.map(children, (child, index) => (
              <div className="col-4" key={child.key + index}>
                {child}
              </div>
            ))}
          </div>
        ),
        fields: [
          {
            type: "field",
            fieldType: "button",
            label: "Submit & Send First Email",
            key: "button1",
            props: {
              className: "form-button",
            },
            expressionProps: {
              disabled: (context, values) =>
                !oneChosen(values) ||
                (values.emailStatus != ChecklistEmailStatus.NoEmailSent && values.emailStatus != null) ||
                values.emailStatus === ChecklistEmailStatus.NoIssuesFound,
              onClick: (context, values) => () => {
                context.issuesFound = true;
                triggerIssuesFoundModal(values, ChecklistEmailStatus.InitialEmail);
              },
            },
          },
          { type: "pInput", key: "emailLabel1", label: "First Email Due Date" },
          {
            type: "field",
            fieldType: "calendar",
            key: "firstEmailDueDate",
            expressionProps: {
              disabled: (context, values) =>
                !oneChosen(values) ||
                (values.emailStatus != ChecklistEmailStatus.NoEmailSent && values.emailStatus != null) ||
                values.emailStatus === ChecklistEmailStatus.NoIssuesFound,
            },
            validation: yup.date().when(["$emailStatus"], ([emailStatus], schema) => {
              if (emailStatus !== ChecklistEmailStatus.NoEmailSent && emailStatus != null) {
                return schema.notRequired();
              }
              return schema
                .required("A response is required")
                .min(today, "The date must be a future date")
                .max(threeMonthsFuture, "The date may not be more than three (3) months in the future");
            }),
          },
          {
            type: "field",
            fieldType: "button",
            label: "Submit & Send First Reminder",
            key: "button2",
            props: {
              className: "form-button",
            },
            expressionProps: {
              disabled: (context, values) =>
                values.emailStatus != ChecklistEmailStatus.InitialEmail || values.emailStatus === ChecklistEmailStatus.NoIssuesFound,
              onClick: (context, values) => () => {
                context.issuesFound = true;
                triggerIssuesFoundModal(values, ChecklistEmailStatus.FirstReminder);
              },
            },
          },
          { type: "pInput", key: "emailLabel2", label: "First Reminder Email Due Date" },
          {
            type: "field",
            fieldType: "calendar",
            key: "firstReminderEmailDueDate",
            expressionProps: {
              disabled: (context, values) => values.emailStatus != ChecklistEmailStatus.InitialEmail,
            },
            validation: yup.date().when(["$emailStatus"], ([emailStatus], schema) => {
              if (emailStatus !== ChecklistEmailStatus.InitialEmail) {
                return schema.notRequired();
              }
              return schema
                .required("A response is required")
                .min(today, "The date must be a future date")
                .max(threeMonthsFuture, "The date may not be more than three (3) months in the future");
            }),
          },
          {
            type: "field",
            fieldType: "button",
            label: "Submit & Send Final Reminder",
            key: "button3",
            props: {
              className: "form-button",
            },
            expressionProps: {
              disabled: (context, values) =>
                values.emailStatus != ChecklistEmailStatus.FirstReminder || values.emailStatus === ChecklistEmailStatus.NoIssuesFound,
              onClick: (context, values) => () => {
                context.issuesFound = true;
                triggerIssuesFoundModal(values, ChecklistEmailStatus.LastReminder);
              },
            },
          },
          { type: "pInput", key: "emailLabel3", label: "Final Reminder Email Due Date" },
          {
            type: "field",
            fieldType: "calendar",
            key: "finalReminderEmailDueDate",
            expressionProps: {
              disabled: (context, values) => values.emailStatus != ChecklistEmailStatus.FirstReminder,
            },
            validation: yup.date().when(["$emailStatus"], ([emailStatus], schema) => {
              if (emailStatus !== ChecklistEmailStatus.FirstReminder) {
                return schema.notRequired();
              }
              return schema
                .required("A response is required")
                .min(today, "The date must be a future date")
                .max(threeMonthsFuture, "The date may not be more than three (3) months in the future");
            }),
          },
        ],
      },
      {
        type: "field",
        key: "internalNotes",
        fieldType: "textarea",
        label: "Internal notes",
        hideExpression: (context) => !context.isInternal,
      },
    ],
  };
  return form;
};

function oneChosen(values: any) {
  return (
    values.specialistTrainingIncomplete ||
    values.minorBuildingModificationsIncomplete ||
    values.attendanceHoursClarification ||
    values.kinderGroupNameClarification ||
    values.bushKinderDates ||
    values.groupSizeClarification ||
    values.staffToChildRatioClarification ||
    values.yearAppliedForClarification ||
    values.commencementDateClarification ||
    values.programTypeClarification ||
    values.schoolExemptionNotSubmitted ||
    values.disabilityOrDiagnosisClarification ||
    values.interestsIncomplete ||
    values.strengthsAndAbilitiesIncomplete ||
    values.groupedBehaviours ||
    values.cmnDiagnosisClarification ||
    values.parentConsentFormIncomplete ||
    values.cmnEvidenceMissing ||
    values.riskMinimisationPlanIncomplete ||
    values.medicalManagementPlanIncomplete ||
    values.disabilityEvidenceMissing ||
    values.adhdEvidence ||
    values.undergoingAssessmentEvidenceMissing ||
    values.kisPlanIncomplete ||
    values.kisPlanPdQuestionsMissed ||
    values.kisPlanNotCurrent ||
    values.kisPlanSameAsPreviousPlan ||
    values.psgTableIncomplete ||
    values.bushKinderRmpIncomplete ||
    values.bushKinderIncorrectRmpProgramDate ||
    values.specialistTrainingQuotesIncomplete ||
    values.specialistTrainingQuotesClarification ||
    values.minorBuildingModificationsQuotesIncomplete ||
    values.appealConsentFormMissing
  );
}

export enum ChecklistEmailStatus {
  NoEmailSent = 0,
  InitialEmail = 1,
  FirstReminder = 2,
  LastReminder = 3,
  NoIssuesFound = 4,
}
